import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/cosmo_logo.svg';
const _withScopeId = n => (_pushScopeId("data-v-56410cfa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header_container"
};
const _hoisted_2 = {
  class: "head"
};
const _hoisted_3 = {
  class: "sys"
};
const _hoisted_4 = {
  class: "nav"
};
const _hoisted_5 = {
  class: "type"
};
const _hoisted_6 = {
  class: "username"
};
const _hoisted_7 = {
  class: "user-tool-list"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LNav = _resolveComponent("LNav");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_avatar = _resolveComponent("el-avatar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: _imports_0,
    width: "150",
    class: "logo",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleGo && $options.handleGo(...args))
  })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_LNav)]), _createElementVNode("div", _hoisted_5, [!$data.isLogin ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    type: "primary",
    class: "login",
    onClick: $options.handleLogin
  }, {
    default: _withCtx(() => [_createTextVNode("登录")]),
    _: 1
  }, 8, ["onClick"])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "islogin",
    onMouseenter: _cache[2] || (_cache[2] = $event => $data.isExitHover = true),
    onMouseleave: _cache[3] || (_cache[3] = $event => $data.isExitHover = false),
    style: {
      "padding-left": "15px",
      "margin-right": "20px",
      "height": "100%",
      "line-height": "72px",
      "padding-top": "15px"
    }
  }, [_createVNode(_component_el_avatar, {
    src: $data.avatarUrl,
    size: 30
  }, null, 8, ["src"]), _createElementVNode("div", _hoisted_6, _toDisplayString($data.info.nickName), 1), _createElementVNode("div", {
    style: _normalizeStyle($data.isExitHover ? 'display:' : 'display:none')
  }, [_createElementVNode("ul", _hoisted_7, [_createElementVNode("li", {
    class: "user-tool-item",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleLogout && $options.handleLogout(...args))
  }, "退出系统 ")])], 4)], 32))])])]);
}